import styled from "styled-components";

interface IProgress {
  name: string;
  active?: boolean; // Adiciona a prop para controlar o estado ativo
}

export default function ProgressBar({ name, active=false }: IProgress) {
  return (
    <Container>
      <Content active={active} />
      <Title active={active}>{name}</Title>
    </Container>
  );
}

const Container = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Content = styled.div<{ active: boolean }>`
  border-radius: 50px;
  height: 5px;
  background-color: ${({ active, theme }) =>
    active ? theme.colors.primary : theme.colors.gray.gray_100};
`;

const Title = styled.p<{ active: boolean }>`
  font-size: 12px;
  color: ${({ active, theme }) =>
    active ? theme.colors.primary : theme.colors.gray.gray_200};
`;
